module.exports = __webpack_public_path__ + "img/emoji_1.66030f77.png";